/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { vendorNoticeControllerCreate } from '../fn/vendor-notice/vendor-notice-controller-create';
import { VendorNoticeControllerCreate$Params } from '../fn/vendor-notice/vendor-notice-controller-create';
import { vendorNoticeControllerDelete } from '../fn/vendor-notice/vendor-notice-controller-delete';
import { VendorNoticeControllerDelete$Params } from '../fn/vendor-notice/vendor-notice-controller-delete';
import { vendorNoticeControllerFindAll } from '../fn/vendor-notice/vendor-notice-controller-find-all';
import { VendorNoticeControllerFindAll$Params } from '../fn/vendor-notice/vendor-notice-controller-find-all';
import { vendorNoticeControllerFindById } from '../fn/vendor-notice/vendor-notice-controller-find-by-id';
import { VendorNoticeControllerFindById$Params } from '../fn/vendor-notice/vendor-notice-controller-find-by-id';
import { vendorNoticeControllerIncreaseViewCount } from '../fn/vendor-notice/vendor-notice-controller-increase-view-count';
import { VendorNoticeControllerIncreaseViewCount$Params } from '../fn/vendor-notice/vendor-notice-controller-increase-view-count';
import { vendorNoticeControllerSearchCursor } from '../fn/vendor-notice/vendor-notice-controller-search-cursor';
import { VendorNoticeControllerSearchCursor$Params } from '../fn/vendor-notice/vendor-notice-controller-search-cursor';
import { vendorNoticeControllerSearchOffset } from '../fn/vendor-notice/vendor-notice-controller-search-offset';
import { VendorNoticeControllerSearchOffset$Params } from '../fn/vendor-notice/vendor-notice-controller-search-offset';
import { vendorNoticeControllerUpdate } from '../fn/vendor-notice/vendor-notice-controller-update';
import { VendorNoticeControllerUpdate$Params } from '../fn/vendor-notice/vendor-notice-controller-update';
import { VendorNoticeDto } from '../models/vendor-notice-dto';

@Injectable({ providedIn: 'root' })
export class VendorNoticeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `vendorNoticeControllerFindAll()` */
  static readonly VendorNoticeControllerFindAllPath = '/api/vendor-notice';

  /**
   * 입점사 공지사항 전체 조회.
   *
   * 입점사 공지사항 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorNoticeControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorNoticeControllerFindAll$Response(params?: VendorNoticeControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VendorNoticeDto>>> {
    return vendorNoticeControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 공지사항 전체 조회.
   *
   * 입점사 공지사항 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorNoticeControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorNoticeControllerFindAll(params?: VendorNoticeControllerFindAll$Params, context?: HttpContext): Observable<Array<VendorNoticeDto>> {
    return this.vendorNoticeControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<VendorNoticeDto>>): Array<VendorNoticeDto> => r.body)
    );
  }

  /** Path part for operation `vendorNoticeControllerSearchOffset()` */
  static readonly VendorNoticeControllerSearchOffsetPath = '/api/vendor-notice/search/offset';

  /**
   * 입점사 공지사항 오프셋 기반 조회.
   *
   * 입점사 공지사항을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorNoticeControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorNoticeControllerSearchOffset$Response(params: VendorNoticeControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return vendorNoticeControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 공지사항 오프셋 기반 조회.
   *
   * 입점사 공지사항을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorNoticeControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorNoticeControllerSearchOffset(params: VendorNoticeControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.vendorNoticeControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `vendorNoticeControllerSearchCursor()` */
  static readonly VendorNoticeControllerSearchCursorPath = '/api/vendor-notice/search/cursor';

  /**
   * 입점사 공지사항 커서 기반 조회.
   *
   * 입점사 공지사항을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorNoticeControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorNoticeControllerSearchCursor$Response(params: VendorNoticeControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return vendorNoticeControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 공지사항 커서 기반 조회.
   *
   * 입점사 공지사항을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorNoticeControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorNoticeControllerSearchCursor(params: VendorNoticeControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.vendorNoticeControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `vendorNoticeControllerFindById()` */
  static readonly VendorNoticeControllerFindByIdPath = '/api/vendor-notice/{id}';

  /**
   * 입점사 공지사항 ID 기반 조회.
   *
   * 입점사 공지사항을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorNoticeControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorNoticeControllerFindById$Response(params: VendorNoticeControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorNoticeDto>> {
    return vendorNoticeControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 공지사항 ID 기반 조회.
   *
   * 입점사 공지사항을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorNoticeControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorNoticeControllerFindById(params: VendorNoticeControllerFindById$Params, context?: HttpContext): Observable<VendorNoticeDto> {
    return this.vendorNoticeControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorNoticeDto>): VendorNoticeDto => r.body)
    );
  }

  /** Path part for operation `vendorNoticeControllerCreate()` */
  static readonly VendorNoticeControllerCreatePath = '/api/vendor-notice/{id}';

  /**
   * 입점사 공지사항 생성.
   *
   * 입점사 공지사항을(를) 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorNoticeControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorNoticeControllerCreate$Response(params: VendorNoticeControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorNoticeDto>> {
    return vendorNoticeControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 공지사항 생성.
   *
   * 입점사 공지사항을(를) 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorNoticeControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorNoticeControllerCreate(params: VendorNoticeControllerCreate$Params, context?: HttpContext): Observable<VendorNoticeDto> {
    return this.vendorNoticeControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorNoticeDto>): VendorNoticeDto => r.body)
    );
  }

  /** Path part for operation `vendorNoticeControllerDelete()` */
  static readonly VendorNoticeControllerDeletePath = '/api/vendor-notice/{id}';

  /**
   * 입점사 공지사항 삭제.
   *
   * 입점사 공지사항을(를) 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorNoticeControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorNoticeControllerDelete$Response(params: VendorNoticeControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorNoticeDto>> {
    return vendorNoticeControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 공지사항 삭제.
   *
   * 입점사 공지사항을(를) 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorNoticeControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorNoticeControllerDelete(params: VendorNoticeControllerDelete$Params, context?: HttpContext): Observable<VendorNoticeDto> {
    return this.vendorNoticeControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorNoticeDto>): VendorNoticeDto => r.body)
    );
  }

  /** Path part for operation `vendorNoticeControllerUpdate()` */
  static readonly VendorNoticeControllerUpdatePath = '/api/vendor-notice/{id}';

  /**
   * 입점사 공지사항 수정.
   *
   * 입점사 공지사항을(를) 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorNoticeControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorNoticeControllerUpdate$Response(params: VendorNoticeControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorNoticeDto>> {
    return vendorNoticeControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 공지사항 수정.
   *
   * 입점사 공지사항을(를) 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorNoticeControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorNoticeControllerUpdate(params: VendorNoticeControllerUpdate$Params, context?: HttpContext): Observable<VendorNoticeDto> {
    return this.vendorNoticeControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorNoticeDto>): VendorNoticeDto => r.body)
    );
  }

  /** Path part for operation `vendorNoticeControllerIncreaseViewCount()` */
  static readonly VendorNoticeControllerIncreaseViewCountPath = '/api/vendor-notice/viewCnt/{id}';

  /**
   * 입점사 공지사항 조회수 증가.
   *
   * 입점사 공지사항 조회수를 증가합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorNoticeControllerIncreaseViewCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorNoticeControllerIncreaseViewCount$Response(params: VendorNoticeControllerIncreaseViewCount$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorNoticeDto>> {
    return vendorNoticeControllerIncreaseViewCount(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 공지사항 조회수 증가.
   *
   * 입점사 공지사항 조회수를 증가합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorNoticeControllerIncreaseViewCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorNoticeControllerIncreaseViewCount(params: VendorNoticeControllerIncreaseViewCount$Params, context?: HttpContext): Observable<VendorNoticeDto> {
    return this.vendorNoticeControllerIncreaseViewCount$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorNoticeDto>): VendorNoticeDto => r.body)
    );
  }

}
